// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_te-0";
export var checkoutRateBadgeLink = "_te-1";